import Vue from 'vue';
import Router from 'vue-router';
import * as Pages from '../pages/index.js';
import { store } from '../App.vue';
import config from 'config';

Vue.use(Router);

const routes = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login/:back',
    name: 'login-back',
    component: Pages.Login,
    props: { store },
  },
  {
    path: '/login',
    name: 'login',
    component: Pages.Login,
    props: { store },
  },
  {
    path: '/registration-1',
    name: 'registration-1',
    component: Pages.Registration1,
    props: { store },
  },
  {
    path: '/registration-2',
    name: 'registration-2',
    component: Pages.Registration2,
    props: { store },
  },
  {
    path: '/registration-success',
    name: 'registration-success',
    component: Pages.RegistrationSuccess,
  },
  {
    path: '/restore-password',
    name: 'restore-password',
    component: Pages.RestorePassword,
    props: { store },
  },
  {
    path: '/restore-password-mail-sent',
    name: 'restore-password-mail-sent',
    component: Pages.RestorePasswordMailSent,
    props: { store },
  },
  {
    path: '/change-password',
    name: 'change-password',
    component: Pages.ChangePassword,
    props: { store },
  },
  {
    path: '/change-password-success',
    name: 'change-password-success',
    component: Pages.ChangePasswordSuccess,
    props: { store },
  },
  {
    path: '/policy',
    name: 'policy',
    component: Pages.Policy,
  },
  {
    path: '/agb',
    name: 'agb',
    component: Pages.Agb,
  },
  {
    path: '/impressum',
    name: 'impressum',
    component: Pages.Impressum,
  },
  {
    path: '/error',
    name: 'error',
    component: Pages.Error,
  },
  {
    path: '/user-profile',
    name: 'user-profile',
    component: Pages.UserProfile,
    props: { store },
  },
  {
    path: '/unsubscribe',
    name: 'unsubscribe',
    component: Pages.Unsubscribe,
    props: { store },
  },
  {
    path: '/unsubscribe-confirmed',
    name: 'unsubscribe-confirmed',
    component: Pages.UnsubscribeConfirmed,
    props: { store },
  },
  {
    path: '/email-verification',
    name: 'email-verification',
    component: Pages.EmailVerification,
    props: { store },
  },
  {
    path: '/profile-deleted',
    name: 'profile-deleted',
    component: Pages.ProfileDeleted,
    props: { store },
  },
  {
    path: '/blank',
    name: 'blank',
    component: Pages.Blank,
  },
  {
    path: '*',
    component: Pages.NotFound,
  }
];

if (config.debugMode) {
  routes.push({
    path: '/index',
    name: 'index',
    component: Pages.Index,
  });
}

export default new Router({
  routes,
});



// WEBPACK FOOTER //
// ./src/app/router.js